import { Label } from '@fluentui/react-components';
import loc from 'owa-localize';
import { observer } from 'owa-mobx-react';
import { headerBrandName } from '../OwaHeader.locstring.json';
import { brandingLabel } from '../OwaHeader.scss';

export default observer(function OwaHeaderBrandingLabel() {
    return (
        <Label className={brandingLabel} size="large" weight="semibold">
            {loc(headerBrandName)}
        </Label>
    );
}, 'OwaHeaderBrandingLabel');
